import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.2 15.1C17.9 14 18.4 12.6 18.4 11.2C18.4 7.2 15.2 4 11.2 4C7.2 4 4 7.2 4 11.2C4 15.2 7.2 18.4 11.2 18.4C13.2 18.4 15 17.6 16.3 16.3L20 20L21.1 18.9L17.2 15.1ZM11.2 16.9C8 16.9 5.5 14.3 5.5 11.2C5.5 8 8 5.5 11.2 5.5C14.3 5.5 16.9 8 16.9 11.2C16.9 14.3 14.3 16.9 11.2 16.9Z",
		fill: "#5162F4"
	})
});
export default SvgSearchreact;
